import { Controller } from '@hotwired/stimulus'
import { debounce } from "hb/lib/utils";

export default class extends Controller {
  static values = {
    field: String,
    type: String
  }

  connect() {
    this.updateValueDebounce = debounce(this.updateValue.bind(this), 200);
  }

  updateValue(name, value) {
    this.dispatch("update", {detail: { name, value }});
  }

  onInput(evt) {
    const {target: {validity, id, value}} = evt;
    if(!validity.valid) return

    this.updateValueDebounce(id, value);
  }
}
